import React from 'react';
import { motion } from 'framer-motion';
import { variants } from '../utils/motionVariants';

export function MotionContainer({ children, ...rest }) {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={variants}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
